<template>
<div>
<ListviewQuestionlistSection v-for="section in $store.state.audit.listview_questionlist" :section="section"></ListviewQuestionlistSection>

</div>
</template>

<script>
import ListviewQuestionlistSection from "./ListviewQuestionlistSection"
export default {

  name: 'ListviewQuestionlist',
  components:{ListviewQuestionlistSection},
  data () {
    return {

    }
  },
  methods:{

  }
}
</script>

<style lang="css" scoped>
</style>